import { useTranslation } from "react-i18next";
import { Label } from "../../forms/Label/Label";
import { Select, TSelectOption } from "../../forms/Select";
import { TDataIntegrationParnterListData } from "@/api/data-ingestion/data-ingestion.types";
import { useMemo } from "react";

type TIngestionTypeDropdownProps = {
  isLoading?: boolean;
  selVal?: string;
  onTypeSel: (value: string) => void;
  typeOptions: TDataIntegrationParnterListData[] | undefined;
};

const IngestionTypeDropdown = ({
  isLoading,
  selVal,
  onTypeSel,
  typeOptions,
}: TIngestionTypeDropdownProps) => {
  const { t } = useTranslation(["common", "dataIngestionPage"]);
  const tranformedValues = useMemo(() => {
    return typeOptions?.map((item) => {
      return {
        value: item?.internal_id,
        label: item?.name,
      };
    });
  }, [typeOptions]);

  return (
    <>
      <Label
        weight={"medium"}
        aria-label="Data Ingestion Type"
        htmlFor="data_ingestion_type"
      >
        {t("dataIngestionPage:DATA_INGESTION.TYPE")}
      </Label>
      <Select
        name="data_ingestion_type"
        options={tranformedValues ?? []}
        value={
          tranformedValues?.find((option) => option.value === selVal) ?? null
        }
        onChange={(option: TSelectOption | null) =>
          onTypeSel(option?.value ?? "")
        }
        getOptionLabel={(option: TSelectOption) => option.label}
        getOptionValue={(option: TSelectOption) => option.value}
        placeholder={t("dataIngestionPage:DATA_INGESTION.SELECT_TYPE")}
        isClearable={true}
        isLoading={isLoading}
      />
    </>
  );
};

export default IngestionTypeDropdown;
